import qs from 'qs';
import { useContext } from 'react';

import type { HubspotFormId } from '@tmh-website/services/form.service';
import { ElectricityTariffContext, PageContext } from '@tmh-website/shared';
import { getCanonicalUrl } from '@tmh-website/services/page.service';
import { type LocalePrefix, PrefixToLocaleMap } from '@tmh-website/shared/const';

export enum HubspotTrackingEventType {
  FormView = 15,
  FormInstall = 16,
  FormVisible = 17,
  FormInteraction = 18,
  FormCompletion = 19,
}

export function useHubSpotTracking(locale: LocalePrefix, asPath: string) {
  const page = useContext(PageContext);
  const { theme } = useContext(ElectricityTariffContext);

  function sendHubSpotEvent(hubspotFormId: HubspotFormId, eventType: HubspotTrackingEventType) {
    if (process.env.NEXT_PUBLIC_ENV !== 'production') {
      // Only run this in production to not submit invalid hubspot events
      return;
    }
    const origin = new URL(process.env.NEXT_PUBLIC_ORIGIN ?? process.env.NX_NEXT_PUBLIC_ORIGIN ?? '');
    if (theme.host) {
      origin.host = theme.host;
    }
    origin.pathname = `${locale}${asPath}`;

    const params = {
      k: eventType,
      // Form id
      fi: hubspotFormId,
      // Screen dimensions
      sd: `${window.innerWidth}x${window.innerHeight}`,
      // Locale
      ln: PrefixToLocaleMap[locale].toLocaleLowerCase(),
      // Account portal id
      a: process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID!,
      // Referer
      r: document.referrer,
      // Canonical url
      ccu: getCanonicalUrl(page, origin.host) ?? origin.toString(),
      // Page url
      pu: origin.toString(),
      // Type?
      t: 'Form',
      // Current timestamp
      cts: new Date().getTime(),
      // hubspotutk Cookie (Hubspot unique token / visitor id).
      // This is not available when this runs and therefore has to be generated manually.
      vi: crypto.randomUUID().replace(/-/g, ''),
    };

    const url = `https://track-${process.env.NEXT_PUBLIC_HUBSPOT_REGION}.hubspot.com/__ptq.gif${qs.stringify(params, {
      addQueryPrefix: true,
    })}`;

    const img = new Image(1, 1);
    img.src = url;
  }

  return { sendHubSpotEvent };
}
